<template>
    <v-modal ref="modal" @opened="modalOpened" >
        <slot slot="title">{{ $t('branch.label.add_brand') }}</slot>
        <slot slot="buttonContent">
            <v-block type="mini" height="stretch" color="white">
                <span class="u-flex-set">
                    <button class="c-button c-button--icon-only" type="button">
                        <svgicon name="added"></svgicon>
                    </button>
                </span>
            </v-block>
        </slot>
        <div class="o-wrapper o-wrapper--center">
            <form action="" class="c-form c-form--horizontal">
                <div class="u-max-700 c-form-row">
                    <v-form-row>
                        <v-custom-select v-model="SelectedBrands"
                                         :options="brandOptions"
                                         search-label="Name" 
                                         option-name="Name"
                                         option-value="Code"  
                                         track-by="Code"
                                         :fluid="true" 
                                         :multiple="true"
                                         :close-on-select="false">
                            <slot slot="label">{{ $t('branch.label.brand') }}</slot>
                        </v-custom-select>
                    </v-form-row>
                    <v-form-row>
                        <div class="c-form-item c-form-item--horizontal">
                            <v-label></v-label>
                            <button @click="addNewBrand" type="button" class="c-button c-button--alpha" :disabled="!canAdd">{{ $t('branch.button.submit') }}</button>
                        </div>
                    </v-form-row>
                </div>
            </form>
        </div>       
    </v-modal>
</template>

<script>
    import VModal from '@/components/modal/Modal'
    import VBlock from '@/components/blocks/Block'
    import VFormRow from '@/components/form/Row'
    import VLabel from '@/components/form/Label'
    import VCustomSelect from '@/components/form/CustomSelect'

    // Store
    import {mapGetters} from 'vuex'

    export default {
        components: {
            VModal,
            VBlock,
            VFormRow,
            VLabel,
            VCustomSelect
        },
        data() {
            return {
                SelectedBrands: []
            }
        },
        props: {
            brandOptions: Array
        },
        computed: {
            canAdd(){
                return this.SelectedBrands.length > 0;
            }
        },
        methods: {
            addNewBrand() {
                this.$emit('brandsAdded', this.SelectedBrands);
                this.$refs.modal.closeDialog();        
            },
            modalOpened(){
                this.SelectedBrands = []
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";
</style>



// WEBPACK FOOTER //
// src/components/branches/AddBrand.vue